import { LogInResponse, ApiResult, httpRequest, Urls } from './Shared';

const AUTH_URL = '/auth';
const ADMIN_USER_URL = '/adminUsers';

export interface SetPasswordInfo {
    username: string;
    password: string;
    token: string;
}

export const logIn = (username: string, password: string): Promise<ApiResult<LogInResponse>> => {
    return httpRequest(`${Urls.BASE_URL}${AUTH_URL}/login`, 'post', {
        username: username,
        password: password
    });
};

export const register = (passwordInfo: SetPasswordInfo): Promise<ApiResult<undefined>> => {
    return httpRequest(`${Urls.BASE_URL}${ADMIN_USER_URL}/register`, 'post', passwordInfo);
};

export const requestPasswordReset = (username: string): Promise<ApiResult<undefined>> => {
    return httpRequest(`${Urls.BASE_URL}${ADMIN_USER_URL}/forgotpassword`, 'post', {
        username: username
    });
};

export const resetPassword = (passwordInfo: SetPasswordInfo): Promise<ApiResult<undefined>> => {
    return httpRequest(`${Urls.BASE_URL}${ADMIN_USER_URL}/resetpassword`, 'post', passwordInfo);
};



// WEBPACK FOOTER //
// ./src/api/Auth.ts